import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { User } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface UsersState {
  users: User[];
}

// Define the initial state using that type
const initialState: UsersState = {
  users: [],
};

export const usersSlice = createSlice({
  name: "users",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setUsers: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload;
    },
  },
});

export const { setUsers } = usersSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getUsersData = (state: RootState) => state.users.users;
export default usersSlice.reducer;
